import useLocalStorage from 'react-use/lib/useLocalStorage';
import React from 'react';
import {LS_PREFIX} from '../../../../../providers/global-state';
import {EditRightPanelTab} from '../../../../../components/layout/page-layout/layout-typings';

export function useDocumentSidebarState(isExploreView: boolean) {
    const [isSidebarOpen, setIsSidebarOpen] = useLocalStorage(
        `${LS_PREFIX}.documents.${isExploreView ? 'explore' : 'edit'}.ontologySidebar.isOpen`,
        false
    );

    const [selectedTab, setSelectedTab] = useLocalStorage(
        `${LS_PREFIX}.documents.${isExploreView ? 'explore' : 'edit'}.ontologySidebar.selectedTab`,
        EditRightPanelTab.METADATA
    );

    const openSidebar = React.useCallback(() => setIsSidebarOpen(true), [setIsSidebarOpen]);

    const closeSidebar = React.useCallback(() => setIsSidebarOpen(false), [setIsSidebarOpen]);

    return {
        isSidebarOpen,
        openSidebar,
        closeSidebar,
        selectedTab,
        setSelectedTab
    };
}
